import { render, staticRenderFns } from "./PostSroMainTable.vue?vue&type=template&id=607fc4c7"
import script from "./PostSroMainTable.vue?vue&type=script&lang=js"
export * from "./PostSroMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports